export default class ProductConfig {
  constructor({ nameKey, nameKeyAlma, hintText, usageOptions, sizeOptions, bottleIcon }) {
    this.nameKey = nameKey;
    this.nameKeyAlma = nameKeyAlma;
    this.hintText = hintText;
    this.usageOptions = usageOptions;
    this.sizeOptions = sizeOptions;
    this.bottleIcon = bottleIcon;
  }
}
